import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ManageShippingAddressesCTA } from "./ctas";

export const PoBoxIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.(
          context.brandOrder
        );
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => DO_NOT_USE_PO_BOXES(strictLocalize),
    getDescription: () => [SOME_BRANDS_DO_NOT_SHIP_TO_PO_BOXES(strictLocalize)],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return ManageShippingAddressesCTA(strictLocalize);
};

const DO_NOT_USE_PO_BOXES = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "We don’t recommend using PO boxes",
    description: {
      text: "Title for the answer of PO box addresses issue",
    },
  });

const SOME_BRANDS_DO_NOT_SHIP_TO_PO_BOXES = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Since some brands don’t ship to PO boxes, we do not recommend using a PO box as your shipping address. You can update the shipping address on your account by using the button below.",
  });
